import { render, staticRenderFns } from "./ModuleIdeaEdit.vue?vue&type=template&id=723ea91e&"
import script from "./ModuleIdeaEdit.vue?vue&type=script&lang=js&"
export * from "./ModuleIdeaEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModuleIdeaEdit.vue?vue&type=style&index=0&id=723ea91e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports